import { render } from "./MyCompanyShareIPO.vue?vue&type=template&id=5e4a0f38&scoped=true"
import script from "./MyCompanyShareIPO.vue?vue&type=script&lang=js"
export * from "./MyCompanyShareIPO.vue?vue&type=script&lang=js"

import "./MyCompanyShareIPO.vue?vue&type=style&index=0&id=5e4a0f38&scoped=true&lang=css"

import exportComponent from "/builds/nex/company-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4a0f38"]])

export default __exports__